/**
 * Centralna funkcja generująca URL do formularza aktualizacji schroniska.
 * Używana wszędzie, gdzie linkujemy do /zglos/:slug.
 *
 * - Preferuje slug (czytelny URL); fallback na ?shelter=UUID gdy slug brak.
 * - Typ: "needs" (potrzeby), "info" (dane), "full" (pełny — domyślny, pomijany w URL).
 */
export type UpdateType = "needs" | "info" | "full";

export interface ShelterRef {
  id: string;
  slug?: string | null;
}

export const buildShelterUpdateUrl = (
  shelter: ShelterRef,
  type: UpdateType = "needs",
): string => {
  const qs = type && type !== "full" ? `?type=${type}` : "";
  if (shelter.slug) return `/zglos/${shelter.slug}${qs}`;
  // Fallback (np. brak slug-a w lokalnym stanie) — stary format z UUID.
  const params = new URLSearchParams({ shelter: shelter.id });
  if (type && type !== "full") params.set("type", type);
  return `/zglos?${params.toString()}`;
};

/**
 * URL do strony wyboru ścieżki aktualizacji (konto opiekuna vs zgłoszenie jako użytkownik).
 * Przekazuje kontekst schroniska (slug lub UUID) oraz typ aktualizacji.
 */
export const buildShelterUpdateChoiceUrl = (
  shelter: ShelterRef,
  type: UpdateType = "needs",
): string => {
  const params = new URLSearchParams();
  params.set("shelter", shelter.slug || shelter.id);
  if (type && type !== "full") params.set("type", type);
  return `/aktualizuj-schronisko?${params.toString()}`;
};

